"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
const Payment_1 = __importDefault(require("./Payment"));
const constants_1 = require("./constants");
const helpers_1 = require("./helpers");
class Account {
    name;
    balance;
    interest;
    minPayment;
    constructor(config) {
        const { name, balance, interest, minPayment } = config;
        this.name = name;
        this.balance = balance;
        this.interest = interest;
        this.minPayment = minPayment;
        if (this.balance <= 0) {
            throw new Error(constants_1.ERROR_MESSAGES.BALANCE_ERROR);
        }
        if (this.interest <= 0) {
            throw new Error(constants_1.ERROR_MESSAGES.INTEREST_RATE_ERROR);
        }
        if (this.minPayment <= 0) {
            throw new Error(constants_1.ERROR_MESSAGES.MIN_PAYMENT_ERROR);
        }
    }
    makePayment(additionalPayment = 0) {
        if (this.balance <= 0) {
            return {
                balanceStart: this.balance,
                balanceEnd: this.balance,
                accruedInterest: 0,
                minPayment: this.minPayment,
                additionalPayment: 0,
                paymentAmount: 0,
                name: this.name,
            };
        }
        const payment = new Payment_1.default({
            balance: this.balance,
            interest: this.interest,
            payment: this.minPayment + additionalPayment,
        });
        const { interest: accruedInterest } = payment;
        // throw error if accrued interest is greater than the minimum payment
        if (accruedInterest >= this.minPayment) {
            throw new Error(constants_1.ERROR_MESSAGES.MIN_PAYMENT_NOT_ENOUGH);
        }
        const originalBalance = this.balance;
        this.balance = payment.balance;
        const paymentAmount = this.balance <= 0 ? originalBalance : payment.payment;
        return {
            balanceStart: (0, helpers_1.toCurrency)(originalBalance),
            balanceEnd: (0, helpers_1.toCurrency)(this.balance),
            accruedInterest,
            minPayment: (0, helpers_1.toCurrency)(this.minPayment),
            additionalPayment,
            paymentAmount,
            name: this.name,
        };
    }
}
module.exports = Account;
